module.exports = __webpack_public_path__ + "static/ongoing-img-ffbe733482baea51738491341f2a3a39.png";